import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import SelectableContainer from '../SelectableContainer/index.js';

/**
 *  `SelectableTabs` create a tabbed content container using `SelectableContainer`s for navigating the content.
 *
 */
function SelectableTabs(_ref) {
  let {
    children,
    defaultActiveKey = 0,
    onSelect = () => {}
  } = _ref;
  const [selectedTab, setSelectedTab] = useState(defaultActiveKey);
  useEffect(() => {
    setSelectedTab(defaultActiveKey);
  }, [defaultActiveKey]);
  const handleSelect = event => {
    setSelectedTab(Number(event.currentTarget?.dataset?.tabIndex));
    onSelect(event, event.currentTarget.getAttribute('id'));
  };
  const renderNavItems = () => React.Children.map(children, (child, index) => {
    const inputProps = {
      ...child.props.inputProps,
      'data-tab-index': index
    };
    return /*#__PURE__*/_jsx(SelectableContainer, {
      inputProps: inputProps,
      checked: selectedTab === index,
      containerClasses: "display-flex flex-1",
      onChange: handleSelect
    }, inputProps.id, /*#__PURE__*/_jsx(React.Fragment, {}, "tab-header-content", child.props.tabHeaderContent), child.props.icon && /*#__PURE__*/_jsx("span", {
      className: "badge badge-circle padding-1"
    }, "icon", child.props.icon));
  });
  const renderContent = () => React.Children.map(children, (child, index) => selectedTab === index ? child : null);
  if (!children) return null;
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "selectableTabs",
    className: "selectable-tabs margin-top-5"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "selectable-tab-header"
  }, void 0, renderNavItems()), /*#__PURE__*/_jsx("div", {
    className: "margin-top-3"
  }, void 0, renderContent()));
}
export default SelectableTabs;